import { z } from "zod";

export const NavigationItemValues = [
  "TODAYS_ACTIONS",
  "PRODUCTION_SCHEDULE",
  "TICKETS",
  "LIVE_PHOTO_REVIEW",
  "WESTHILL_XA_EVENTS",
  "BIDS",
  "PROJECTS",
  "PROJECTS_V2",
  "TASKS",
  "TASKS_V2",
  "ACTIONABLES",
  "CONTRACTORS",
  "RECRUITING",
  "CONTRACTOR_DASHBOARD",
  "TRAINING",
  "DISPATCH",
  "FINANCIAL_CONSOLE",
  "ADMIN",
  "TRAINING_CONTRACTORS",
  "DEVELOPER_PORTAL",
  "INSURANCE",
  "DEVTOOLS",
  "MY_ORGANIZATION",
  "PROJECT_MILESTONES",
  "VIEW_TODAYS_ACTIONS",
  "VIEW_PRODUCTION_SCHEDULE",
  "VIEW_MY_TASKS",
  "VIEW_OPERATIONS_COORDINATOR",
  "VIEW_STANDARD_QUOTING",
  "VIEW_UPSELL_QUOTING",
  "VIEW_LIVE_QUOTING",
  "VIEW_QUOTE_REVIEW",
  "VIEW_INTRO_CALL",
  "VIEW_PRE_PRODUCTION",
  "VIEW_CONTRACTOR_PRODUCTION",
  "VIEW_FINAL_CHECK_OFF",
  "VIEW_FINANCE",
  "VIEW_PERMITTING",
  "VIEW_CHANGE_ORDERS",
  "VIEW_POST_INSTALL_ISSUES",
  "VIEW_BLOCKING_TASKS",
  "VIEW_UPSELLS",
  "VIEW_REVIEW_FINANCIAL_ADJUSTMENTS",
  "VIEW_CONTRACTOR_DOCUMENTS",
  "VIEW_REVIEW_BIDS",
  "VIEW_REMI_LABOR",
  "VIEW_INSURANCE_QUOTING",
  "VIEW_ENTERPRISE_MANAGEMENT",
  "VIEW_INSURANCE_ALL_ASSIGNMENTS",
  "VIEW_INSURANCE_MY_ASSIGNMENTS",
  "VIEW_INSURANCE_ORG_ASSIGNMENTS",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_PENDING_ESTIMATE",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_CANCELED",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_APPROVED",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_CORRECTIONS_REQUESTED",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_PENDING_APPROVAL",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_COMP_ESTIMATES",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_SOLD",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_NOT_SOLD",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_STARTED",
  "VIEW_INSURANCE_MY_ASSIGNMENTS_JOB_COMPLETED",
  "VIEW_ESTIMATING",
  "VIEW_ESTIMATING_APPROVALS",
  "VIEW_MY_ESTIMATING_TASKS",
  "VIEW_MY_BLOCKING_TASKS",
  "VIEW_MY_WESTHILL_TASKS",
  "VIEW_UNASSIGNED_WESTHILL_TASKS",
  "VIEW_MY_OPENLY_TASKS",
  "VIEW_UNASSIGNED_OPENLY_TASKS",
  "ESCALATIONS",
  "ESCALATION_OVERVIEW",
  "ESCALATION_HUB",
  "ESCALATION_TABLE",
  "VIEW_TRAVELERS_CLEANUP",
  "VIEW_1099_ESTIMATING",
  "VIEW_CORRECTIONS",
  "VIEW_PARTNER_SUCCESS_TASKS",
  "VIEW_APPEASEMENTS",
  "VIEW_VENDOR_CREDITS",
  "VIEW_CONCESSION_APPROVALS",
  "VIEW_ITEL_TASKS",
  "VIEW_SALES_VISITS",
  "VIEW_CONTRACTOR_TRAINING",
  "REMITTANCE",
  "MY_QUEUE",
] as const;

const NavigationItemSchema = z.enum(NavigationItemValues);
export const NavigationItem = NavigationItemSchema.enum;
export type NavigationItem = (typeof NavigationItemValues)[number];
